import { render, staticRenderFns } from "./game_n.vue?vue&type=template&id=39a84ed1&scoped=true"
import script from "./game_n.vue?vue&type=script&lang=js"
export * from "./game_n.vue?vue&type=script&lang=js"
import style0 from "./game_n.vue?vue&type=style&index=0&id=39a84ed1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a84ed1",
  null
  
)

export default component.exports